export default "__VITE_ASSET__a04a29fd__"